import { motion } from 'framer-motion';

export default function Impressum() {
  return (
    <div data-testid="impressum-page" className="min-h-screen bg-cream">
      {/* Header */}
      <section className="pt-32 pb-16 bg-olive-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-heading text-4xl md:text-5xl text-cream"
          >
            Impressum
          </motion.h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white p-8 md:p-12 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.1)]"
          >
            <div className="space-y-8 font-body text-muted-foreground">
              <div>
                <h2 className="font-heading text-2xl text-olive-900 mb-4">
                  Angaben gemäß § 5 TMG
                </h2>
                <p className="leading-relaxed">
                  <span className="font-semibold text-olive-900">Ivan Muggianu</span><br />
                  Ristorante – Pizzeria Il Girasole<br />
                  Zeppelinstraße 15<br />
                  85399 Hallbergmoos
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-olive-900 mb-4">
                  Kontakt
                </h2>
                <p className="leading-relaxed">
                  Telefon: <a href="tel:+498119999888" className="text-terracotta hover:underline">0811 / 999 98 88</a><br />
                  Telefax: 0811 / 999 98 31<br />
                  E-Mail: <a href="mailto:info@ristorante-ilgirasole.de" className="text-terracotta hover:underline">info@ristorante-ilgirasole.de</a>
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-olive-900 mb-4">
                  Umsatzsteuer-ID
                </h2>
                <p className="leading-relaxed">
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                  <span className="font-semibold text-olive-900">DE272924165</span>
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-olive-900 mb-4">
                  EU-Streitschlichtung
                </h2>
                <p className="leading-relaxed">
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                  <a 
                    href="https://ec.europa.eu/consumers/odr/" 
                    className="text-terracotta hover:underline ml-1" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    https://ec.europa.eu/consumers/odr/
                  </a>
                  <br /><br />
                  Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-olive-900 mb-4">
                  Verbraucherstreitbeilegung / Universalschlichtungsstelle
                </h2>
                <p className="leading-relaxed">
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
